var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"gcheck",class:{ on: _vm.checked },attrs:{"type":"button","role":"checkbox","data-gcheck":_vm.name,"aria-checked":String(_vm.checked),"aria-label":_vm.ariaLabel,"title":_vm.boxTitle,"disabled":_vm.disabled},on:{"click":_vm.toggle}},[_c('font-awesome-icon',{staticClass:"gcheck-tick",attrs:{"icon":"check"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }